import React from 'react';
import { hot } from 'react-hot-loader';
import LogoReplace from '../../hocs/LogoReplace/LogoReplace';
import Overlay from '../../hocs/Overlay/Overlay';
import { purifier } from '../../utils/dom';
import { translate } from '../../utils/locale';
import { urlify } from '../../utils/string';
import s from './SizeChart.scss';

const SizeChart = ({ setup, product, sizeChartClickHandler, isShowing, closeOverlayHandler, plp = false }) => {
	if (!product.measurementChartRows || Object.keys(product.measurementChartRows).length === 0) return null;

	const sizeGroups = {};
	if (product.measurementChartRows && /%\s*$/.test(Object.keys(product.measurementChartRows)[0])) {
		// Create size groups to work with sizes that span several rows.
		Object.keys(product.measurementChartRows).forEach((row) => {
			const sizeGroup = row.replace(/[0-9]*%\s*$/, '');
			if (!sizeGroups[sizeGroup]) sizeGroups[sizeGroup] = [];
			sizeGroups[sizeGroup] = [
				...sizeGroups[sizeGroup],
				[row.replace(/[0-9]*%\s*$/, ''), ...Object.keys(product.measurementChartRows[row]).map((key) => product.measurementChartRows[row][key])],
			];
		});
	} else if (product.measurementChartRows) {
		sizeGroups.general = Object.keys(product.measurementChartRows).reduce((acc, row) => (
			[
				...acc,
				[row, ...Object.keys(product.measurementChartRows[row]).map((key) => product.measurementChartRows[row][key])],
			]
		), []);
	}
	const relevantSizeNames = product.sizes.map((size) => urlify(size.name.replace(/\s/g, '')));
	const measurementChartInfo = (product.measurementChart && setup?.statics?.sizeChartInformation && setup.statics.sizeChartInformation.filter((sci) => parseInt(sci.sizeID, 10) === parseInt(product.measurementChart, 10))) || [];

	return (
		<Overlay variantClasses={[plp ? 'overlay__plp' : null]} isShowing={isShowing} closeOverlayHandler={closeOverlayHandler}>
			<div id={`size-chart-product-id-${product.groupId}`} className={s.sizeChart}>
				<table className={s.sizeChart_table}>
					<thead>
						<tr>
							<th aria-label={product.name}><LogoReplace str={product.name} /></th>
							{
								Object.keys(product.measurementChartRows).slice(0, 1).map((row) => (
									Object.keys(product.measurementChartRows[row]).map((key) => <th key={key}>{ key.split('%').map((t) => <span key={t}>{ t }</span>) }</th>)
								))
							}
						</tr>
					</thead>
					{
						Object.keys(sizeGroups).map((sizeGroup) => (
							<tbody key={sizeGroup} className={[s.sizeChart_table_body, (sizeGroup !== 'general' ? s.sizeChart_table_body__grouped : null)].join(' ')}>
								{
									sizeGroups[sizeGroup].filter((sizeRow) => relevantSizeNames.indexOf(urlify(sizeRow[0].replace(/\s/g, ''))) !== -1 || relevantSizeNames.indexOf(urlify(sizeRow[1].replace(/\s/g, ''))) !== -1).map((sizeRow, i) => (
										<tr key={`${sizeGroup}_${sizeRow.reduce((acc, sizeKey) => acc + (sizeKey || '_'), '')}`} onClick={sizeChartClickHandler}>
											{
												sizeRow.slice(sizeGroup !== 'general' && i > 0 ? 1 : 0).map((size, j) => <td key={urlify(`${sizeGroup}_${size}`)} rowSpan={sizeGroup !== 'general' && i === 0 && j === 0 ? sizeGroups[sizeGroup].length : null}>{ size }</td>)
											}
										</tr>
									))
								}
							</tbody>
						))
					}
				</table>
				{ measurementChartInfo[0] && <div className={s.sizeChart_info} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, measurementChartInfo[0].sizeText)) }} /> }
			</div>
		</Overlay>
	);
};

export default hot(module)(SizeChart);
